import React from 'react'
import './WithdrawalFunds.css'

// import { ReactComponent as Close } from '../../../assets/icons/assets/Close.svg'
// import { ReactComponent as BTCIcon } from '../../../assets/icons/assets/assetsBtc.svg'
import Close from '../../../assets/icons/assets/Close.png'
import BTCIcon from '../../../assets/icons/assets/assetsBtc.png'
import { ReactComponent as USDIcon } from '../../../assets/icons/assets/header_dollar.svg'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

const WithdrawalFunds = ({state, setState}) => {
    const {t} = useTranslation()
    const navigate = useNavigate()
    return (
        <div className={state == true ? "withdrawall withdrawall-Active" : "withdrawall"}>
            <div className="withdrawall-Headline">
                <div className="textBlock">
                    <h2>{t("deposit.withdrawal.title")}</h2>
                    <p>{t("deposit.withdrawal.subtitle")}</p>
                </div>
                {/* <Close onClick={()=>{setState(false)}}/> */}
                <img src={Close} alt="" onClick={()=>{setState(false)}} />
            </div>
            <div className="withdrawall-wrapper">
                <div className="withdrawall-block" onClick={()=> {navigate("/account/withdraw-crypto")}}>
                    {/* <BTCIcon /> */}
                    <img src={BTCIcon} alt="" />
                    <div className="textBlock">
                        <h2>{t("deposit.withdrawal.items.crypto.title")}</h2>
                        <p>{t("deposit.withdrawal.items.crypto.description")}</p>
                    </div>
                </div>
                <div className="withdrawall-block" onClick={()=> {navigate("/account/withdraw")}}>
                    <USDIcon />
                    <div className="textBlock">
                        <h2>{t("deposit.withdrawal.items.fiat.title")}</h2>
                        <p>{t("deposit.withdrawal.items.fiat.description")}</p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default WithdrawalFunds